module.exports = __webpack_public_path__ + "img/Libra.8ead346e.png";